.popup {
    position: absolute;
    z-index: 1000;
    transition: transform 0.1s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;

    &.top {
        margin-top: -0.1rem;
        transform: scaleY(0);
        transform-origin: bottom;
        flex-direction: column;
    }

    &.bottom {
        margin-top: 0.1rem;
        transform: scaleY(0);
        transform-origin: top;
        flex-direction: column;
    }

    &.left {
        margin-left: -0.1rem;
        transform: scaleX(0);
        transform-origin: right;
    }

    &.right {
        margin-left: 0.1rem;
        transform: scaleX(0);
        transform-origin: left;
    }

    &.show {
        transform: scale(1);
    }
}

.info {
    --cur-tooltip-bg: var(--tooltip-bg);
    --cur-tooltip-color: var(--tooltip-color);
}

.error {
    --cur-tooltip-bg: var(--tooltip-error-bg);
    --cur-tooltip-color: var(--tooltip-error-color);
}

.success {
    --cur-tooltip-bg: var(--tooltip-success-bg);
    --cur-tooltip-color: var(--tooltip-success-color);
}

.warning {
    --cur-tooltip-bg: var(--tooltip-warning-bg);
    --cur-tooltip-color: var(--tooltip-warning-color);
}

.content {
    background: var(--cur-tooltip-bg);
    color: var(--cur-tooltip-color);
    padding: 0.25rem;
    border-radius: 4px;
    font-size: small;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    position: relative;
}

.arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: relative;

    &.top {
        border-width: 8px 4px 0 4px;
        border-color: var(--cur-tooltip-bg) transparent transparent transparent;
    }

    &.right {
        border-width: 4px 8px 4px 0;
        border-color: transparent var(--cur-tooltip-bg) transparent transparent;
    }

    &.bottom {
        border-width: 0 4px 8px 4px;
        border-color: transparent transparent var(--cur-tooltip-bg) transparent;
    }

    &.left {
        border-width: 4px 0 4px 8px;
        border-color: transparent transparent transparent var(--cur-tooltip-bg);
    }
}

